import styled from "styled-components";

const Caption = styled.div`
  p {
    margin-bottom: 0;
  }
  text-align: center;
`;

export default Caption;



// WEBPACK FOOTER //
// ./src/components/caption.js